export const translations = {
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      portfolio: 'Portfolio',
      about: 'About',
      contact: 'Contact',
    },
    hero: {
      tagline: 'Web Design Agency',
      headline: 'We craft digital experiences that move people.',
      sub: 'MadisonFred is a creative studio specializing in web design, development, branding, and UI/UX — building bold digital products for ambitious brands.',
      cta: 'Start a Project',
      cta2: 'View Our Work',
    },
    marquee: {
      items: ['Web Design', 'Development', 'Branding', 'UI/UX', 'Strategy', 'Digital Products', 'Creative Direction'],
    },
    services: {
      label: '',
      title: 'Services',
      items: [
        {
          title: 'Web Design',
          desc: 'Pixel-perfect, responsive websites that captivates your audience and embodies your brand identity. We design with purpose, every element intentional for your business needs.',
          num: '01',
        },
        {
          title: 'Web Development',
          desc: 'High-performance, scalable applications built with advanced technologies. From landing pages to complex platforms engineered for speed and reliability.',
          num: '02',
        },
        {
          title: 'Branding',
          desc: 'Global brand identity systems including logos, typography, color palettes, and guidelines. We build brands that stand apart and stand the test of time.',
          num: '03',
        },
        {
          title: 'UI/UX Design',
          desc: 'User-centered design that balances aesthetics with intuitive functionality. Research-driven interfaces that innovate and transform.',
          num: '04',
        },
      ],
    },
    portfolio: {
      label: '',
      title: 'Portfolio',
      projects: [
        {
          title: 'Lumina App',
          category: 'Mobile Design',
          desc: 'A sleek, dark-mode mobile application for a fintech startup. Clean interfaces, smooth animations, and intuitive navigation.',
        },
        {
          title: 'Archway Studio',
          category: 'Web Design & Development',
          desc: 'Website redesign for a leading architecture firm. Showcasing their portfolio with immersive imagery and minimal UI.',
        },
        {
          title: 'Noir Collective',
          category: 'Branding & Identity',
          desc: 'Exclusive brand identity for luxury fashion labels. Logo systems, stationery accessories and every touchpoint designed for premium impact.',
        },
        {
          title: 'Globe Gourmand',
          category: 'Web Design & Branding',
          desc: 'Elegant culinary website celebrating world gastronomy. Refined editorial design with immersive food photography.',
          url: 'https://globegourmand.com',
        },
      ],
    },
    about: {
      label: 'Who We Are',
      title: 'About',
      p1: 'MadisonFred is a digital studio founded on excellent design concepts. We partner with ambitious brands and startups to create digital experiences that are appealing, perfectly formed and effective.',
      p2: 'Our team combines strategic thinking with creative execution. We don\'t just make things look good — we solve problems, tell stories, and build systems that scale.',
      p3: 'Based in the intersection of design and technology, we bring a multidisciplinary approach to every project.',
      stats: [
        { num: '100+', label: 'Projects Delivered' },
        { num: '12+', label: 'Years Experience' },
      ],
      founders: [
        { name: 'Madison', role: 'Co-founder & Creative Director' },
        { name: 'Fred', role: 'Co-founder & Strategy Lead' },
      ],
    },
    testimonials: {
      label: 'Client Stories',
      title: 'Testimonials',
      clientsLabel: 'Trusted by forward-thinking brands',
      items: [
        {
          quote: 'MadisonFred transformed our entire digital presence. Their attention to detail and creative vision exceeded all expectations. The result? A 40% increase in user engagement and revenus.',
          name: 'Sarah Chen',
          role: 'CEO, Aurora Tech',
        },
        {
          quote: 'Working with this team felt like a true partnership. They understood our brand DNA from day one and delivered a website that perfectly captures who we are.',
          name: 'Marcus Dubois',
          role: 'Founder, Nexus Group',
        },
        {
          quote: 'The branding package created for us is exceptional. Every touchpoint, from the logo to the website, tells a cohesive story. Highly recommend.',
          name: 'Elena Rodriguez',
          role: 'Creative Director, Prism Digital',
        },
      ],
    },
    contact: {
      label: 'Get in Touch',
      title: 'Let\'s Work Together',
      desc: 'Have a project in mind? We would love to hear about it. Complete the form below and we will get back to you within 24 hours.',
      addressLabel: 'Address',
      name: 'Your Name',
      email: 'Your Email',
      company: 'Company (optional)',
      service: 'Select a Service',
      serviceOptions: ['Web Design', 'Web Development', 'Branding', 'UI/UX Design'],
      message: 'Tell us about your project',
      send: 'Send Message',
      sending: 'Sending...',
      success: 'Message sent successfully! We\'ll be in touch soon.',
      error: 'Something went wrong. Please try again.',
    },
    newsletter: {
      title: 'Stay in the loop',
      desc: 'Get design insights and studio updates straight to your inbox.',
      placeholder: 'Enter your email',
      cta: 'Subscribe',
      success: 'Subscribed successfully!',
      error: 'Already subscribed or invalid email.',
    },
    footer: {
      tagline: 'Crafting digital experiences since 2017.',
      rights: 'All rights reserved.',
    },
  },
  fr: {
    nav: {
      home: 'Accueil',
      services: 'Services',
      portfolio: 'Portfolio',
      about: 'A propos',
      contact: 'Contact',
    },
    hero: {
      tagline: 'Agence de Web Design',
      headline: 'Nous créons des experiences digitales qui marquent.',
      sub: 'MadisonFred est un studio creatif spécialisé en web design, developpement, branding et UI/UX — concevant des produits digitaux audacieux pour des marques ambitieuses.',
      cta: 'Demarrer un Projet',
      cta2: 'Voir Nos Projets',
    },
    marquee: {
      items: ['Web Design', 'Developpement', 'Branding', 'UI/UX', 'Strategie', 'Produits Digitaux', 'Direction Creative'],
    },
    services: {
      label: '',
      title: 'Services',
      items: [
        {
          title: 'Web Design',
          desc: 'Des sites web pixel-perfect et responsives qui captivent votre audience et incarnent votre identite de marque. Nous concevons avec intention, chaque élément est reflechi.',
          num: '01',
        },
        {
          title: 'Developpement Web',
          desc: 'Des applications performantes et évolutives construites avec des technologies modernes. Des landing pages aux plateformes complexes — conçues pour la rapidité et la fiabilité.',
          num: '02',
        },
        {
          title: 'Branding',
          desc: 'Systemes d\'identité de marque globaux incluant logos, typographie, palettes de couleurs et guidelines. Nous construisons des marques qui se démarquent.',
          num: '03',
        },
        {
          title: 'Design UI/UX',
          desc: 'Design centre utilisateur qui équilibre esthetique et fonctionnalite intuitive. Des interfaces guidées par la recherche qui ravissent et convertissent.',
          num: '04',
        },
      ],
    },
    portfolio: {
      label: '',
      title: 'Portfolio',
      projects: [
        {
          title: 'Lumina App',
          category: 'Design Mobile',
          desc: 'Une application mobile élégante en mode sombre pour une startup fintech. Interfaces epurees, animations fluides et navigation intuitive.',
        },
        {
          title: 'Archway Studio',
          category: 'Web Design & Developpement',
          desc: 'Refonte du site web pour un cabinet d\'architecture de premier plan. Mise en valeur de leur portfolio avec des images immersives et une interface minimale.',
        },
        {
          title: 'Noir Collective',
          category: 'Branding & Identite',
          desc: 'Identite de marque exclusive pour labels de mode luxe. Systemes de logos, papeterie et chaque point de contact conçu pour un impact premium.',
        },
        {
          title: 'Globe Gourmand',
          category: 'Web Design & Branding',
          desc: 'Site culinaire élégant célébrant la gastronomie mondiale. Design editorial raffine avec photographie culinaire immersive.',
          url: 'https://globegourmand.com',
        },
      ],
    },
    about: {
      label: 'Qui Sommes-Nous',
      title: 'A Propos',
      p1: 'MadisonFred est un studio de design digital fonde sur l\'excellence du design. Nous collaborons avec des marques ambitieuses et des startups pour creer des experiences digitales attrayantes, parfaitement conçues et efficaces.',
      p2: 'Notre equipe combine reflexion strategique et execution creative. Nous ne nous contentons pas de rendre les choses belles — nous resolvons des problemes, racontons des histoires et construisons des systemes evolutifs.',
      p3: 'A l\'intersection du design et de la technologie, nous apportons une approche multidisciplinaire a chaque projet.',
      stats: [
        { num: '100+', label: 'Projets Livres' },
        { num: '12+', label: 'Ans d\'Experience' },
      ],
      founders: [
        { name: 'Madison', role: 'Co-fondatrice & Directrice Creative' },
        { name: 'Fred', role: 'Co-fondateur & Directeur Strategie' },
      ],
    },
    testimonials: {
      label: 'Temoignages Clients',
      title: 'Temoignages',
      clientsLabel: 'La confiance de marques visionnaires',
      items: [
        {
          quote: 'MadisonFred a transforme toute notre presence digitale. Leur souci du detail et leur vision creative ont depasse toutes nos attentes. Resultat ? Une augmentation de 40% de l\'engagement utilisateur.',
          name: 'Sarah Chen',
          role: 'PDG, Aurora Tech',
        },
        {
          quote: 'Travailler avec cette equipe etait un veritable partenariat. Ils ont compris notre ADN de marque des le premier jour et ont livre un site qui capture parfaitement qui nous sommes.',
          name: 'Marcus Dubois',
          role: 'Fondateur, Nexus Group',
        },
        {
          quote: 'Le package branding qu\'ils ont cree pour nous est exceptionnel. Chaque point de contact, du logo au site web, raconte une histoire coherente. Je recommande vivement.',
          name: 'Elena Rodriguez',
          role: 'Directrice Creative, Prism Digital',
        },
      ],
    },
    contact: {
      label: 'Nous Contacter',
      title: 'Travaillons Ensemble',
      desc: 'Vous avez un projet en tete ? Nous serions ravis d\'en discuter. Remplissez le formulaire ci-dessous et nous vous repondrons sous 24 heures.',
      addressLabel: 'Adresse',
      name: 'Votre Nom',
      email: 'Votre Email',
      company: 'Entreprise (optionnel)',
      service: 'Choisir un Service',
      serviceOptions: ['Web Design', 'Developpement Web', 'Branding', 'Design UI/UX'],
      message: 'Parlez-nous de votre projet',
      send: 'Envoyer le Message',
      sending: 'Envoi en cours...',
      success: 'Message envoye avec succes ! Nous vous recontacterons bientot.',
      error: 'Une erreur est survenue. Veuillez reessayer.',
    },
    newsletter: {
      title: 'Restez informe',
      desc: 'Recevez des insights design et les actualites du studio directement dans votre boite mail.',
      placeholder: 'Entrez votre email',
      cta: 'S\'abonner',
      success: 'Abonnement reussi !',
      error: 'Deja abonne ou email invalide.',
    },
    footer: {
      tagline: 'Createurs d\'experiences digitales depuis 2017.',
      rights: 'Tous droits reserves.',
    },
  },
};
